import { MetagraphIndexerBaseUrl } from '@/common/consts/api.ts';
import { DeviceUpdate } from '@/common/types/device_checkins.ts';
import { createResourcesProvider } from '@/common/utils/resources_provider.tsx';

type IDevice = {
  address: string;
  pubKey: string | null;
  rewardsAddress: string | null;
  createdAt: IISODate;
  updatedAt: IISODate;
  snapshotOrdinal: number;
};

const [DevicesProvider, useDevicesProvider] = createResourcesProvider(
  'DevicesProvider',
  {
    checkins: {
      apiUrl: `${MetagraphIndexerBaseUrl}/devices/checkins`,
      initialState: [] as DeviceUpdate[],
      queryParams: {} as {
        pubKey?: string;
        ordinal?: number;
      },
      resource: {} as DeviceUpdate[],
      pathParams: {},
      pagination: { size: 10 }
    },
    device: {
      apiUrl: `${MetagraphIndexerBaseUrl}/devices/:deviceId`,
      initialState: null,
      queryParams: {},
      resource: {} as IDevice,
      pathParams: {} as { deviceId: string }
    }
  }
);

export { DevicesProvider, useDevicesProvider };
